module.exports = __webpack_public_path__ + "static/media/Mobile_Data_BIG_DATA_E_DATA_MINING.5044d564.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/bigData_Mining/Mobile_Data_BIG_DATA_E_DATA_MINING.png
// module id = 94
// module chunks = 0